import { Website } from '@website-builder/model/domain/website/website';

export class WebsiteTemplateNormalizer {
  static normalizeInPlace(data: Website): Website {
    return Website.normalizeInPlace(data);
  }
}
